import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { SearchResultsStore } from 'stores/search-results-store';

import { FiltersToggle } from 'components/search/sort-filter/filters-toggle';
import { MapToggle } from 'components/search/map/map-toggle';
import { PlaybackFilter } from 'components/search/playback/playback-filter';
import { ResultsTitle } from './results-title';

import { PrimaryPageMessagingModel } from 'src/common/models';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';
import { classNames } from 'uitk-react-utils';
import { UitkSecondaryButton } from 'uitk-react-button';

export interface ToolsProps extends LocalizedComponentProps {
  className?: string;
  searchResults?: SearchResultsStore;
}

export interface ToolsState {
  toolsActive: boolean;
}

@withLocalization
@inject('searchResults')
@observer
export class Tools extends React.Component<ToolsProps, ToolsState> {
  private searchToolsWrapper;

  public static defaultProps = {
    l10n: null
  };

  constructor(props: ToolsProps) {
    super(props);

    this.state = { toolsActive: false };
    this.searchToolsWrapper = React.createRef();
  }

  public componentDidMount() {
    this.setState({
      toolsActive: true
    });
  }

  public render() {
    const { l10n, searchResults, className } = this.props;
    const { primaryPageMessagingModel } = searchResults;
    const toolsClasses = classNames('tools', {
      className
    });

    return (
      <section className={toolsClasses} ref={this.searchToolsWrapper.value}>
        <ResultsTitle
          isLoading={searchResults.isLoading}
          l10n={l10n}
          resultCountMessage={searchResults.resultTitleModel}
          loyaltyMessagingModel={searchResults.loyaltyMessagingModel}
          searchCriteria={searchResults.searchCriteria}
        />
        <PayInInstallmentsMessaging primaryPageMessagingModel={primaryPageMessagingModel} />
        <Viewport>
          <ViewSmall>
            <Actions isActive={this.state.toolsActive} />
          </ViewSmall>
          <ViewLarge>
            <span>{/*Removing this, will make whatever in view small show up in all breakpoints */}</span>
          </ViewLarge>
        </Viewport>
        <PlaybackFilter />
      </section>
    );
  }
}

interface PayInInstallmentsMessagingProps {
  primaryPageMessagingModel: PrimaryPageMessagingModel;
}

const PayInInstallmentsMessaging = ({ primaryPageMessagingModel }: PayInInstallmentsMessagingProps) => {
  if (!primaryPageMessagingModel || !primaryPageMessagingModel.description) {
    return null;
  }

  return (
    <section className="uitk-cell uitk-type-medium uitk-type-center" data-stid="pay-in-installments-messaging">
      <span className="uitk-type-200 uitk-neutral-700">{primaryPageMessagingModel.description}</span>
    </section>
  );
};

interface ActionsProps {
  isActive: boolean;
}
const Actions = ({ isActive }: ActionsProps) => (
  <div className="uitk-flex uitk-flex-gap-two tools__actions all-t-padding-two">
    <div className="uitk-flex-grow-2">
      <FiltersToggle
        buttonComponent={UitkSecondaryButton}
        isActive={isActive}
        isFullWidth={true}
        label="hotels.searchResults.openFiltersDialog.label"
        a11yMessage="hotels.searchResults.appliedFiltersCount.a11yLabel"
        rfrr=":FilterControl"
        stid="open-hotel-filters"
      />
    </div>
    <div className="uitk-flex-grow-1">
      <MapToggle isActive={isActive} />
    </div>
  </div>
);
